import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Alert, FormControl,  IconButton, InputAdornment, FormLabel, Grid, Paper, Snackbar } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'providers/AuthContextProvider';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="www.leidenfrost.io">
        Leidenfrost.
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function SignIn(props) {
  const navigate = useNavigate()
  const [loading, setLoading] = React.useState(false);
  const [emailError, setEmailError] = React.useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = React.useState('');
  const [showPassword, setShowPassword] = React.useState(false);
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('');
  const [snackbarState, setSnackbarState] = React.useState({open:false,message:"",status:"info"});
  const {login} = useAuth();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({open:false,message:snackbarState.message,status:snackbarState.status})
  };

  const handleSubmit = async(event) => {
    event.preventDefault();

    if (emailError || passwordError) {
      setSnackbarState({open: true, message: "¡Por favor llena todos lo campos!", status: "warning"})
      return;
    }

    const data = new FormData(event.currentTarget);
    const email = data.get('email')
    const password = data.get('password')

    setLoading(true)

    const requestBody = { email: email, password: password }
    const response =  await login(requestBody)

    if(response.success){
      navigate('/');
    }else{
      setSnackbarState({ open: true, message: response.message || "Error al iniciar sesión", status: "error" })
    }
    
  };

  const validateInputs = () => {
    const email = document.getElementById('email');
    const password = document.getElementById('password');

    let isValid = true;

    if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
      setEmailError(true);
      setEmailErrorMessage('Please enter a valid email address.');
      isValid = false;
    } else {
      setEmailError(false);
      setEmailErrorMessage('');
    }

    if (!password.value || password.value.length < 6) {
      setPasswordError(true);
      setPasswordErrorMessage('Password must be at least 6 characters long.');
      isValid = false;
    } else {
      setPasswordError(false);
      setPasswordErrorMessage('');
    }

    return isValid;
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    
    <Grid container component="main" sx={{ height: '100vh' }}>
      <CssBaseline />
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/future.jpg?alt=media&token=155aafbd-f8bd-45d8-98bf-33e4285f3b3f)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
      </Grid>
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 8,
            mx: 4,
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Stack spacing={2} useFlexGap sx={{ width: { xs: '100%', sm: '100%' }}}>
          <Box
              alignSelf= 'center'
              component="img"
              sx={{
                height: 120,
                width: 300,
              }}
              alt="officia logo."
              src="https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/leidenfrost.svg?alt=media&token=aa8b35e7-10dc-4f45-9530-63fef6768eca"
            />
          </Stack>
          <Box component="form" noValidate onSubmit={handleSubmit}>
            <Stack spacing={2} >
              <FormControl >
                <FormLabel htmlFor="email">Email</FormLabel>
                <TextField
                  sx={{mt:1}}
                  error={emailError}
                  helperText={emailErrorMessage}
                  id="email"
                  type="email"
                  name="email"
                  placeholder="your@email.com"
                  autoComplete="email"
                  autoFocus
                  required
                  variant="outlined"
                  color={emailError ? 'error' : 'primary'}
                />
              </FormControl>
              <FormControl>
                <FormLabel htmlFor="password">Password</FormLabel>
                <TextField
                  sx={{mt:1}}
                  error={passwordError}
                  helperText={passwordErrorMessage}
                  name="password"
                  placeholder="••••••"
                  type={showPassword ? 'text' : 'password'}
                  disabled={loading}
                  id="password"
                  autoComplete="current-password"
                  autoFocus
                  required
                  variant="outlined"
                  color={passwordError ? 'error' : 'primary'}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  inputProps={{
                    autoComplete: 'new-password', 
                  }}
                />
              </FormControl>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={validateInputs}
              >
                Sign in
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link href="#" variant="body2">
                    Forgot your password?
                  </Link>
                </Grid>
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbarState.open} onClose={handleClose}>
                  <Alert
                    onClose={handleClose}
                    severity={snackbarState.status}
                    variant="filled"
                  >
                    {snackbarState.message}
                  </Alert>
                </Snackbar>
              </Grid>
            </Stack>
            <Copyright sx={{ mt: 5 }} />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}